import React, { useState, forwardRef, useEffect, useRef } from "react";
import urls from "../../constants";
import { default as ReactSelect } from "react-select";
import Select, { components } from "react-select";
import FetchData from "../../providers/dataProvider";
import { CheckNull } from "../../utils/Validate";
import { ValidateMessages } from "../../constants/ValidateConstants";
import Modal from "react-bootstrap/Modal";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "13px",
    minHeight: "30px",
    height: "30px",
    borderRadius: "6px",
    color: "#000000",
  }),
};
const inlineTableSelectStyle = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    border: state.isFocused ? "1px solid #004e91" : "1px solid #b4babf",
    backgroundColor: "#f9fbfc",
    fontSize: "14px",
    fontWeight: 500,
    minHeight: "32px",
    height: "32px",
    borderRadius: "6px",
    color: "#000811",
    cursor: "pointer",
  }),
  valueContainer: (base) => ({
    ...base,
    height: "30px",
    padding: "0 8px",
    fontSize: "13px",
  }),

  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    fontSize: "13px",
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: "30px",
  }),

  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
    color: "#004e91",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "4px",
  }),
  singleValue: (base) => ({
    ...base,
    margin: 0,
    color: "#000811",
    fontWeight: 500,
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

export const Configuration = ({
  setProductTab,
  ProductTab,
  setProductConfig,
  productConfig,
  attributes,
  setAttributes,
  configSetting,
  setConfigSetting,
  setProductConfigVariant,
  productVariant,
  setvariantsarray,
  variantsArray,
  addProduct,
  attributeDetails,
  setattributeDetails,
  setRecalculateModalShow,
  setProductName,
  productName,
  setEditConfig,
  editConfig,
  attributeArray,
  setAttributeArray,
  attributeValueArray,
  setAttributeValueArray,
  groupArray,
  setGroupArray,
  recalculate,
  inline = false,
  onConfigurationChange,
  headerExtra = null,
  groupFilter = null,
}) => {
  const [distributertag, setDistributerTag] = useState([]);
  const [configDetails, setConfigDetails] = useState([]);
  const [showConfig, setShowConfig] = useState(false);
  const [attributeFilterDetails, setattributeFilterDetails] = useState([]);
  const [configError, setConfigError] = useState({});
  const [openConfiguration, setOpenConfiguration] = useState(false);

  const {
    data: productsconfig,
    loading: productConfigLoading,
    error: productConfigError,
  } = FetchData("productconfig", {
    id: ProductTab?.id?.hasOwnProperty("productName")
      ? ProductTab?.id?.productSubGroupId
      : ProductTab?.id?.id,
  });

  useEffect(() => {
    if (productsconfig) {
      if (ProductTab?.id?.hasOwnProperty("productName")) {
        setConfigDetails(
          productsconfig?.filter((item) => item.id === ProductTab?.id?.id)
        );
      } else {
        setConfigDetails(productsconfig);
      }
    }
  }, [productsconfig, ProductTab?.id?.id, ProductTab?.activeAssemblyKey]);

  useEffect(() => {
    if (editConfig?.status === true) {
      HandleApplyConfig(editConfig?.configSetting);
      setEditConfig({});
    }
  }, [editConfig?.status]);

  useEffect(() => {
    const materialConfig = configSetting?.find(
      (item) => item.attributeId === urls?.MATERIAL_OF_CONSTRUCTION
    );
    if (!materialConfig?.valueName) return;

    const isGalvanized =
      materialConfig.valueName.trim() === "Galvanized Steel";

    const axleValue = isGalvanized
      ? "Galvanized"
      : "304 Stainless Steel";

    const jackshaftValue = isGalvanized
      ? "Yes"
      : "Yes - with vertical interconnect";

    const updateAttribute = (attributeId, valueName) => {
      const attr = attributeDetails?.find(
        (item) =>
          item.attributeId === attributeId &&
          item.valueName === valueName
      );

      if (!attr) return null;

      return {
        attributeId: attr.attributeId,
        attributeName: attr.attributeName,
        valueId: attr.valueId,
        valueName: attr.valueName,
        groupName: attr.groupName,
        productGroupId: attr.productGroupId,
        productSubGroupId: attr.productSubGroupId,
      };
    };

    const axleConfig = updateAttribute(urls?.CFSD_AXLE_MATERIAL, axleValue);
    const jackshaftConfig = updateAttribute(urls?.CFSD_JACKSHAFT, jackshaftValue);

    const currentAxle = configSetting.find(
      (item) => item.attributeId === urls?.CFSD_AXLE_MATERIAL
    );
    const currentJackshaft = configSetting.find(
      (item) => item.attributeId === urls?.CFSD_JACKSHAFT
    );

    const axleNeedsUpdate =
      axleConfig && currentAxle?.valueName !== axleConfig.valueName;
    const jackshaftNeedsUpdate =
      jackshaftConfig && currentJackshaft?.valueName !== jackshaftConfig.valueName;

    if (!axleNeedsUpdate && !jackshaftNeedsUpdate) {
      return;
    }

    setConfigSetting((prev) => {
      let updated = [...prev];

      const replaceConfig = (config) => {
        if (!config) return;

        const index = updated.findIndex(
          (item) => item.attributeId === config.attributeId
        );

        if (index >= 0) {
          updated[index] = config;
        } else {
          updated.push(config);
        }
      };

      replaceConfig(axleConfig);
      replaceConfig(jackshaftConfig);

      return updated;
    });
  }, [configSetting, attributeDetails]);

  useEffect(() => {
    if (configDetails && configDetails?.length > 0) {
      let prod_config = [];
      configDetails?.map((configitem) => {
        if (configitem?.isActive === true) {
          configitem?.productSpecGroupMaps?.map((specgroupitem) => {
            specgroupitem?.productSpecMaps?.map((specitem) => {
              if (specitem?.isActive === true) {
                if (specitem?.productSpecValueMaps?.length > 0) {
                  specitem?.productSpecValueMaps?.map((specivalues) => {
                    if (specivalues?.isActive === true) {
                      prod_config.push({
                        productId: configitem?.id,
                        imageUrl: configitem?.imageUrl,
                        productName: configitem?.productName,
                        productNomenclature: configitem?.nomencleature,
                        groupId: specgroupitem?.groupId,
                        groupName: specgroupitem?.groupName,
                        groupSequence: specgroupitem?.sequence,
                        attributeId: specitem?.attributeId,
                        attributeName: specitem?.attributeName,
                        isSelectionParameter: specitem?.isSelectionParameter,
                        valueId: specivalues?.valueId,
                        valueItemId: specivalues?.id,
                        valueName: specivalues?.valueName,
                        nomenclature: specivalues?.nomenclature,
                        sequenceValue: specivalues?.sequence,
                        sequenceAttribute: specitem?.sequence,
                        productGroupId: configitem?.productGroupId,
                        productSubGroupId: configitem?.productSubGroupId,
                      });
                    }
                  });
                } else {
                  prod_config.push({
                    productId: configitem?.id,
                    productName: configitem?.productName,
                    imageUrl: configitem?.imageUrl,
                    groupId: specgroupitem?.groupId,
                    groupName: specgroupitem?.groupName,
                    sequenceAttribute: specitem?.sequence,
                    attributeId: specitem?.attributeId,
                    attributeName: specitem?.attributeName,
                    isSelectionParameter: specitem?.isSelectionParameter,
                    valueId: "",
                    valueName: "",
                    valueItemId: "",
                    sequenceAttribute: specitem?.sequence,
                    productGroupId: configitem?.productGroupId,
                    productSubGroupId: configitem?.productSubGroupId,
                  });
                }
              }
            });
          });
        }
      });
      setattributeDetails(prod_config);
      setattributeFilterDetails(prod_config);
    }
  }, [configDetails]);

  useEffect(() => {
    if (attributeFilterDetails) {
      let attribute_Array = [];
      let group_Array = [];
      let attribute_Value_Array = [];
      attributeFilterDetails?.map((attrItem) => {
        group_Array.push({
          groupId: attrItem?.groupId,
          groupName: attrItem?.groupName,
          productGroupId: attrItem?.productGroupId,
          productSubGroupId: attrItem?.productSubGroupId,
        });
        attribute_Array.push({
          attributeName: attrItem?.attributeName,
          attributeId: attrItem?.attributeId,
          groupId: attrItem?.groupId,
          groupName: attrItem?.groupName,
          sequenceAttribute: attrItem?.sequenceAttribute,
          isSelectionParameter: attrItem?.isSelectionParameter,
        });
        if (attrItem?.valueName)
          attribute_Value_Array.push({
            attributeName: attrItem?.attributeName,
            attributeId: attrItem?.attributeId,
            valueName: attrItem?.valueName,
          });
      });

      const uniqueAttribute = attribute_Array.filter(
        (attr, index, self) =>
          index === self.findIndex((u) => u.attributeId === attr.attributeId)
      );
      const uniqueValueAttribute = attribute_Value_Array.filter(
        (attr, index, self) =>
          index ===
          self.findIndex(
            (u) =>
              u.valueName === attr.valueName && u.attributeId === attr.attributeId
          )
      );
      const uniqueGroup = group_Array.filter(
        (attr, index, self) =>
          index === self.findIndex((u) => u.groupId === attr.groupId)
      );

      setAttributeArray(
        [...uniqueAttribute].sort((a, b) => a.sequenceAttribute - b.sequenceAttribute)
      );
      setAttributeValueArray(uniqueValueAttribute);
      setGroupArray(uniqueGroup);
    }
  }, [attributeFilterDetails]);

  useEffect(() => {
    if (ProductTab?.id?.hasOwnProperty("productName")) {
      if (configSetting?.length > 0) return;

      let configArray = [];
      groupArray?.map((groupItem) => {
        let selectedAttribute = attributeArray?.filter(
          (selectAttr) => selectAttr?.groupId === groupItem?.groupId
        );
        selectedAttribute?.map((attrItem) => {
          let value = attributeValueArray?.filter(
            (valueItem) => valueItem?.attributeId === attrItem?.attributeId
          );
          if (value?.length == 2) {
            configArray.push({
              attributeId: attrItem.attributeId,
              attributeName: attrItem.attributeName,
              valueId: value[0]?.valueName,
              valueName: value[0]?.valueName,
              groupName: groupItem?.groupName,
              productGroupId: groupItem?.productGroupId,
              productSubGroupId: groupItem?.productSubGroupId,
            });
          }
        });
      });
      setConfigSetting(configArray);
    }
  }, [groupArray, attributeArray, attributeValueArray]);

  const handleChange = (selectedOption, attribute, ptype, group) => {
    const currentConfig = configSetting ?? [];

    if ((ptype === "select" && selectedOption?.label) || ptype === "text") {
      const index = currentConfig.findIndex(
        (item) => item.attributeId === attribute.attributeId
      );
      if (index === -1) {
        setConfigSetting([
          ...currentConfig,
          {
            attributeId: attribute.attributeId,
            attributeName: attribute.attributeName,
            valueId: ptype === "select" ? selectedOption?.value : 0,
            valueName: ptype === "select" ? selectedOption?.label : "",
            groupName: group?.groupName,
            productGroupId: group?.productGroupId,
            productSubGroupId: group?.productSubGroupId,
            specialValue: ptype === "text" ? selectedOption.target.value : "",
          },
        ]);
      } else {
        if (selectedOption?.target?.name === "RAL Color") {
          if (selectedOption?.target?.value !== "") {
            setConfigSetting((prev) => {
              const newArr = [...(prev ?? [])];
              newArr[index] = {
                ...newArr[index],
                specialValue: ptype === "text" ? selectedOption.target.value : "",
              };
              return newArr;
            });
          } else {
            setConfigSetting((prevState) =>
              (prevState ?? []).filter((item) => item.attributeId !== urls?.RAL_COLOUR)
            );
          }
        } else {
          setConfigSetting((prev) => {
            const newArr = [...(prev ?? [])];
            newArr[index] = {
              ...newArr[index],
              valueId: ptype === "select" ? selectedOption?.value : 0,
              valueName: ptype === "select" ? selectedOption?.label : "",
              groupName: group?.groupName,
              productGroupId: group?.productGroupId,
              productSubGroupId: group?.productSubGroupId,
              specialValue: ptype === "text" ? selectedOption.target.value : "",
            };
            return newArr;
          });
        }
      }
    } else {
      setConfigSetting(
        currentConfig.filter((item) => item.attributeId !== attribute.attributeId)
      );
    }

    const isAluminiumSelection =
      attribute?.attributeId === urls?.MATERIAL_OF_CONSTRUCTION &&
      ptype === "select" &&
      selectedOption?.label?.trim().toLowerCase() === "aluminium";

    if (isAluminiumSelection) {
      setConfigSetting((prev) => {
       
        const normalize = (value) => String(value ?? "").trim().toLowerCase();
        const aluminiumCasingThickness = attributeDetails?.find(
          (item) =>
            item?.attributeId === urls?.VAV_CASING_THICKNESS &&
            normalize(item?.valueName) === "1.2 mm (18 ga)"
        );

        if (!aluminiumCasingThickness) return prev;

        const updated = [...(prev ?? [])];
        const thicknessIndex = updated.findIndex(
          (item) => item?.attributeId === urls?.VAV_CASING_THICKNESS
        );
        const thicknessConfig = {
          attributeId: aluminiumCasingThickness.attributeId,
          attributeName: aluminiumCasingThickness.attributeName,
          valueId: aluminiumCasingThickness.valueId,
          valueName: aluminiumCasingThickness.valueName,
          groupName: aluminiumCasingThickness.groupName,
          productGroupId: aluminiumCasingThickness.productGroupId,
          productSubGroupId: aluminiumCasingThickness.productSubGroupId,
        };

        if (thicknessIndex >= 0) {
          updated[thicknessIndex] = thicknessConfig;
        } else {
          updated.push(thicknessConfig);
        }

        return updated;
      });
    }

    if (
      attribute?.attributeId === urls.BANK_OF_BLATE &&
      (selectedOption?.value === urls.BANK_OF_BLATE_NO_VALUE ||
        CheckNull(selectedOption?.label) === "")
    ) {
      setConfigSetting((prevState) =>
        (prevState ?? []).filter((item) => !urls.BANK_OFF_BLATE_ARRAY.includes(item.attributeId))
      );
    } else if (
      attribute?.attributeId === urls.PLENUM &&
      (selectedOption?.value === urls.PLENUM_NONE_VALUE ||
        CheckNull(selectedOption?.label) === "")
    ) {
      setConfigSetting((prevState) =>
        (prevState ?? []).filter(
          (item) => !urls.PLENUM_ATTRIBUTES_WITH_ARRAY.includes(item.attributeId)
        )
      );
    } else if (
      attribute?.attributeId === urls.PLENUM &&
      (selectedOption?.value === urls.PLENUM_WITHOUT_INSULATION_VALUE ||
        CheckNull(selectedOption?.label) === "")
    ) {
      setConfigSetting((prevState) =>
        (prevState ?? []).filter(
          (item) =>
            !urls.PLENUM_ATTRIBUTES_WITHOUT_NOTALLOWEDARRAY.includes(item.attributeId)
        )
      );
    }
    if (typeof onConfigurationChange === "function") {
      onConfigurationChange();
    }
  };

  useEffect(() => {
    const normalize = (value) => String(value ?? "").trim().toLowerCase();
    const isAluminium = configSetting?.some(
      (item) =>
        item?.attributeId === urls?.MATERIAL_OF_CONSTRUCTION &&
        normalize(item?.valueName) === "aluminium"
    );
    const aluminiumCasingThickness = attributeDetails?.find(
      (item) =>
        item?.attributeId === urls?.VAV_CASING_THICKNESS &&
        normalize(item?.valueName) === "1.2 mm (18 ga)"
    );

    if (!isAluminium || !aluminiumCasingThickness) return;

    const currentThickness = configSetting?.find(
      (item) => item?.attributeId === urls?.VAV_CASING_THICKNESS
    );
    if (normalize(currentThickness?.valueName) === "1.2 mm (18 ga)") return;

    const thicknessConfig = {
      attributeId: aluminiumCasingThickness.attributeId,
      attributeName: aluminiumCasingThickness.attributeName,
      valueId: aluminiumCasingThickness.valueId,
      valueName: aluminiumCasingThickness.valueName,
      groupName: aluminiumCasingThickness.groupName,
      productGroupId: aluminiumCasingThickness.productGroupId,
      productSubGroupId: aluminiumCasingThickness.productSubGroupId,
    };

    setConfigSetting((prev) => {
      const thicknessIndex = (prev ?? []).findIndex(
        (item) => item?.attributeId === urls?.VAV_CASING_THICKNESS
      );
      if (thicknessIndex < 0) return [...(prev ?? []), thicknessConfig];

      const updated = [...prev];
      updated[thicknessIndex] = thicknessConfig;
      return updated;
    });
  }, [configSetting, attributeDetails]);

  useEffect(() => {
    if (!configSetting?.length) {
      if (attributeDetails?.length > 0) {
        setattributeFilterDetails(attributeDetails);
      }
      return;
    }

    const validConfigSettings = configSetting.filter(
      (item) => item?.valueName && item?.valueName !== ""
    );

    if (!validConfigSettings?.length) return;

    const commonProductIds = validConfigSettings.reduce((acc, configItem, index) => {
      const matchingIds = new Set(
        attributeDetails
          .filter(
            (attrItem) =>
              attrItem?.valueName === configItem?.valueName &&
              attrItem?.attributeId === configItem?.attributeId
          )
          .map((attrItem) => attrItem?.productId)
      );
      return index === 0
        ? matchingIds
        : new Set([...acc].filter((id) => matchingIds.has(id)));
    }, new Set());

    const filteredDetails =
      commonProductIds.size > 0
        ? attributeDetails.filter((item) => commonProductIds.has(item?.productId))
        : attributeDetails;

    setattributeFilterDetails(filteredDetails);
  }, [configSetting, attributeDetails]);

  const HandleClearConfig = () => {
    setattributeFilterDetails(attributeDetails);
    setConfigSetting([]);
    if (typeof onConfigurationChange === "function") {
      onConfigurationChange();
    }
  };

  useEffect(() => {
    if (recalculate === true) {
      HandleVariantsChange(configSetting);
    }
  }, [recalculate]);

  const HandleFindProduct = (paramConfigSetting) => {
    let productDetails = {};

    const normalize = (v) => (v ?? "").toString().trim().toLowerCase();

    const configFilter = paramConfigSetting?.filter(
      (item) => !urls.SHOW_ATTRIBUTES_ARRAY.includes(item.attributeId)
    ) ?? [];
    const meaningfulConfig = configFilter.filter(
      (item) =>
        normalize(item?.valueName) !== "" &&
        item?.attributeId !== urls?.RAL_COLOUR
    );

    let commonProducts = null;

    meaningfulConfig.forEach((config) => {
      const matches = attributeDetails.filter(
        (attr) =>
          normalize(attr.attributeName) === normalize(config.attributeName) &&
          normalize(attr.valueName) === normalize(config.valueName)
      );

      if (matches.length === 0) return;

      if (commonProducts === null) {
        commonProducts = matches;
      } else {
        commonProducts = commonProducts.filter((item) =>
          matches.some((m) => m.productName === item.productName)
        );
      }
    });

    const finalCandidates = commonProducts ?? [];

    if (finalCandidates.length > 0) {
      setProductName(finalCandidates[0]);
      productDetails = finalCandidates[0];
    } else {
      setProductName({});
      productDetails = {};
    }
    return productDetails;
  };

  const HandleApplyConfig = (paramConfigSetting) => {
    let errorCheck = false;
    paramConfigSetting?.map((config) => {
      if (
        config?.attributeId === urls?.RAL_COLOUR &&
        config?.valueName === "Custom Colour" &&
        CheckNull(config?.specialValue) === ""
      ) {
        setConfigError({
          [config?.attributeName]: ValidateMessages.REQUIRED(config?.attributeName),
        });
        errorCheck = true;
      }
    });

    if (errorCheck === false) {
      setConfigError({});
      const productDetails = HandleFindProduct(paramConfigSetting);

      let completeConfigSetting = paramConfigSetting;
      if (productDetails?.productId) {
        const fullProductAttrs = attributeDetails.filter(
          (attr) => attr.productId === productDetails.productId
        );
        const userTouchedIds = new Set(
          paramConfigSetting.map((c) => c.attributeId)
        );
        const backfilled = fullProductAttrs
          .filter(
            (attr) =>
              !userTouchedIds.has(attr.attributeId) &&
              attr.valueName &&
              attr.attributeId !== urls?.RAL_COLOUR
          )
          .map((attr) => ({
            attributeId: attr.attributeId,
            attributeName: attr.attributeName,
            valueId: attr.valueId,
            valueName: attr.valueName,
            groupName: attr.groupName,
            productGroupId: attr.productGroupId,
            productSubGroupId: attr.productSubGroupId,
          }));
        completeConfigSetting = [...paramConfigSetting, ...backfilled];
        setConfigSetting(completeConfigSetting);
      }

      if (productConfig?.productName?.productId) {
        const productActuallyChanged =
          productConfig?.productName?.productId !== productDetails?.productId;

        const hasFilledVariants = variantsArray?.some(
          (varItem) =>
            urls?.VALIDATION_VARIANT_ARRAY?.includes(varItem?.variantId) &&
            varItem?.variantValue !== "" &&
            varItem?.variantValue !== null &&
            varItem?.variantValue !== undefined
        );

        if (
          productActuallyChanged &&
          hasFilledVariants &&
          !editConfig?.status
        ) {
          setRecalculateModalShow(true);
        } else {
          setProductConfig((prev) => ({
            ...prev,
            configuration: completeConfigSetting,
            productName: productDetails,
          }));
          HandleVariantsChange(completeConfigSetting);
        }
      } else {
        setProductConfig((prev) => ({
          ...prev,
          configuration: completeConfigSetting,
          productName: productDetails,
        }));
        HandleVariantsChange(completeConfigSetting);
      }
      setOpenConfiguration(false);
    }
  };

  const lastAppliedSignatureRef = useRef(null);

  const getConfigSignature = (arr) =>
    JSON.stringify(
      [...(arr || [])]
        .map((c) => ({
          attributeId: c.attributeId,
          valueName: c.valueName,
          specialValue: c.specialValue || "",
        }))
        .sort((a, b) => a.attributeId - b.attributeId)
    );

  useEffect(() => {
    if (!configSetting || configSetting.length === 0) {
      lastAppliedSignatureRef.current = null;
      return;
    }

    const currentSignature = getConfigSignature(configSetting);
    if (currentSignature === lastAppliedSignatureRef.current) {
      return;
    }

    lastAppliedSignatureRef.current = currentSignature;
    HandleApplyConfig(configSetting);
  }, [configSetting]);

  const HandleVariantsChange = (paramConfigSetting) => {
    const transitionNone = paramConfigSetting?.some(
      (item) =>
        urls?.TRANSITION?.includes(item?.attributeId) &&
        item?.valueName === urls?.TRANSITION_NONE
    );
    const transitionRound = paramConfigSetting?.some(
      (item) =>
        urls?.TRANSITION?.includes(item?.attributeId) &&
        item?.valueName === urls?.TRANSITION_ROUND
    );
    const transitionSquare = paramConfigSetting?.some(
      (item) =>
        urls?.TRANSITION?.includes(item?.attributeId) &&
        item?.valueName === urls?.TRANSITION_SQUARE
    );
    const plenumNone = paramConfigSetting?.some(
      (item) =>
        item?.attributeId === urls?.PLENUM && item?.valueName === urls?.TRANSITION_NONE
    );
    const bopLength = paramConfigSetting?.some(
      (item) =>
        urls?.BLANK_PLATE === item?.attributeId &&
        urls?.BLANK_PLATE_NONE?.includes(item?.valueName?.trim())
    );

    let configVariantArray = productVariant?.filter((item) =>
      transitionNone
        ? !urls?.TRANSITION_VARIANT_NONE.includes(item?.variantId)
        : transitionRound
          ? !urls?.TRANSITION_SQUARE_LENGTH_HEIGHT.includes(item?.variantId)
          : transitionSquare
            ? !urls?.TRANSITION_ROUND_DIA.includes(item?.variantId)
            : !urls?.TRANSITION_VARIANT_NONE.includes(item?.variantId)
    );
    configVariantArray = configVariantArray?.filter((item) =>
      plenumNone ? !urls?.PLENUM_NONE.includes(item?.variantId) : true
    );

    configVariantArray = configVariantArray?.filter((item) =>
      bopLength
        ? urls?.BOP_LENGTH !== item?.variantId
        : true
    );

    let filteredVariantsArray = variantsArray?.filter((item) =>
      configVariantArray.some((item1) => item1.variantId === item.variantId)
    );
    let filterVariants = configVariantArray?.filter(
      (item) => !variantsArray.some((item1) => item1.variantId === item.variantId)
    );

    let productVariantsArray = [];
    addProduct?.forEach((prod) => {
      filterVariants?.forEach((item) => {
        const filterVar =
          filteredVariantsArray?.filter((pvar) => pvar.sid === prod.sid) || {};
        productVariantsArray.push({
          sid: prod?.sid,
          id: 0,
          quoteProductItemId: filterVar?.[0]?.quoteProductItemId,
          variantId: item?.variantId,
          variantValue: item?.variantValue || "",
          inputByUser: item?.inputByUser,
        });
      });
    });

    setvariantsarray([...filteredVariantsArray, ...productVariantsArray]);
    setProductConfigVariant(configVariantArray);
  };

  const checkShowAttribute = (attribute) => {
    let showAttribute = false;
    if (urls.BANK_OFF_BLATE_ARRAY.includes(attribute?.attributeId)) {
      let filterVar = configSetting?.filter(
        (svar) =>
          svar.valueName === urls.BANK_OF_BLATE_YES_VALUE &&
          svar.attributeId === urls.BANK_OF_BLATE
      );
      if (filterVar && filterVar?.length > 0) showAttribute = true;
    }
    if (urls.PLENUM_ATTRIBUTES_WITHOUT_ALLOWEDARRAY.includes(attribute?.attributeId)) {
      let filterVar = configSetting?.filter(
        (svar) =>
          svar?.valueName === urls.PLENUM_WITHOUT_INSULATION_VALUE &&
          svar?.attributeId === urls.PLENUM
      );
      if (filterVar && filterVar?.length > 0) showAttribute = true;
    }
    if (urls.PLENUM_ATTRIBUTES_WITH_ARRAY.includes(attribute?.attributeId)) {
      let filterVar = configSetting?.filter(
        (svar) =>
          svar?.valueName?.replace(/\s+/g, " ") === urls.PLENUM_WITH_INSULATION_VALUE &&
          svar?.attributeId === urls.PLENUM
      );
      if (filterVar && filterVar?.length > 0) showAttribute = true;
    }
    return showAttribute;
  };

  const isRalCustomColour = (attribute, matchedConfig) => {
    if (attribute?.attributeId !== urls?.RAL_COLOUR) return false;
    return matchedConfig?.valueName === "Custom Colour";
  };

  const GetSelectComponent = (attribute, group) => {
    let options = [];
    let selectedValue = null;

    const matchedConfig = configSetting?.find(
      (svar) => svar?.attributeId === attribute?.attributeId
    );
    const isAluminiumCasingThickness =
      attribute?.attributeId === urls?.VAV_CASING_THICKNESS &&
      configSetting?.some(
        (item) =>
          item?.attributeId === urls?.MATERIAL_OF_CONSTRUCTION &&
          String(item?.valueName ?? "").trim().toLowerCase() === "aluminium"
      );
    const valueArray = attributeDetails
      ?.filter(
        (item) =>
          item.attributeId === attribute?.attributeId &&
          item.valueName &&
          item.valueName !== "" &&
          (!isAluminiumCasingThickness ||
            String(item?.valueName).trim().toLowerCase() === "1.2 mm (18 ga)")
      )
      .reduce((acc, item) => {
        if (!acc.find((v) => v.valueName === item.valueName)) {
          acc.push(item);
        }
        return acc;
      }, []).sort((a, b) => (a.sequenceValue || 0) - (b.sequenceValue || 0));

    if (valueArray?.length > 0) {
      valueArray.forEach((attriValues) => {
        options.push({
          label: attriValues?.valueName,
          value: attriValues?.valueName,
        });
      });

      if (matchedConfig) {
        if (isRalCustomColour(attribute, matchedConfig)) {
          selectedValue = matchedConfig.specialValue || "";
        } else if (matchedConfig?.valueName) {
          selectedValue = {
            label: matchedConfig.valueName,
            value: matchedConfig.valueName,
          };
        }
      }
    } else {
      if (matchedConfig) {
        selectedValue =
          matchedConfig.specialValue !== undefined && matchedConfig.specialValue !== ""
            ? matchedConfig.specialValue
            : matchedConfig.valueName || "";
      }
    }

    return (
      <>
        {checkShowAttribute(attribute) === false &&
          urls.SHOW_ATTRIBUTES_ARRAY.includes(attribute?.attributeId) ? (
          ""
        ) : (
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
            <div>
              <label>{attribute?.attributeName}</label>

              {isAluminiumCasingThickness ? (
                <input
                  type="text"
                  className="form-control"
                  value="1.2 mm (18 ga)"
                  disabled
                  readOnly
                />
              ) : valueArray?.length > 0 ? (
                isRalCustomColour(attribute, matchedConfig) ? (
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={`Enter ${attribute?.attributeName}`}
                      value={typeof selectedValue === "string" ? selectedValue : ""}
                      name={attribute?.attributeName}
                      onChange={(e) => handleChange(e, attribute, "text", group)}
                    />
                    <span
                      className="input-group-text"
                      id="basic-addon2"
                      onClick={() =>
                        handleChange(
                          { target: { value: "", name: attribute?.attributeName } },
                          attribute,
                          "text",
                          group
                        )
                      }
                    >
                      <i className="fas fa-times"></i>
                    </span>
                  </div>
                ) : (
                  <Select
                    className="basic-multi-select"
                    options={options}
                    name={attribute?.attributeName}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    isClearable={false}
                    isSearchable={true}
                    onChange={(e) => handleChange(e, attribute, "select", group)}
                    allowSelectAll={false}
                    value={selectedValue}
                    styles={style}
                    placeholder={`Choose ${attribute?.attributeName}`}
                    menuPlacement="auto"
                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                    menuPosition="fixed"
                    minMenuHeight={0}
                  />
                )
              ) : (
                <input
                  type="text"
                  className="form-control"
                  placeholder={`Enter ${attribute?.attributeName}`}
                  value={typeof selectedValue === "string" ? selectedValue : ""}
                  name={attribute?.attributeName}
                  onChange={(e) => handleChange(e, attribute, "text", group)}
                />
              )}

              {configError?.[attribute?.attributeName] && (
                <p className="form-error">{configError?.[attribute?.attributeName]}</p>
              )}
            </div>
          </div>
        )}
      </>
    );
  };

  const GetTableValueControl = (attribute, group) => {
    let options = [];
    let selectedValue = null;

    const matchedConfig = configSetting?.find(
      (svar) => svar?.attributeId === attribute?.attributeId
    );
    const valueArray = attributeDetails
      ?.filter(
        (item) =>
          item.attributeId === attribute?.attributeId &&
          item.valueName &&
          item.valueName !== ""
      )
      .reduce((acc, item) => {
        if (!acc.find((v) => v.valueName === item.valueName)) {
          acc.push(item);
        }
        return acc;
      }, []).sort((a, b) => (a.sequenceValue || 0) - (b.sequenceValue || 0));
    if (valueArray?.length > 0) {
      valueArray.forEach((attriValues) => {
        options.push({
          label: attriValues?.valueName,
          value: attriValues?.valueName,
        });
      });

      if (matchedConfig) {
        if (isRalCustomColour(attribute, matchedConfig)) {
          selectedValue = matchedConfig.specialValue || "";
        } else if (matchedConfig?.valueName) {
          selectedValue = {
            label: matchedConfig.valueName,
            value: matchedConfig.valueName,
          };
        }
      }
    } else {
      if (matchedConfig) {
        selectedValue =
          matchedConfig.specialValue !== undefined && matchedConfig.specialValue !== ""
            ? matchedConfig.specialValue
            : matchedConfig.valueName || "";
      }
    }
    const isAutoField =
      attribute.attributeId === urls?.CFSD_AXLE_MATERIAL ||
      attribute.attributeId === urls?.CFSD_JACKSHAFT;
    const isAluminiumCasingThickness =
      attribute?.attributeId === urls?.VAV_CASING_THICKNESS &&
      configSetting?.some(
        (item) =>
          item?.attributeId === urls?.MATERIAL_OF_CONSTRUCTION &&
          String(item?.valueName ?? "").trim().toLowerCase() === "aluminium"
      );

    const showAsInput = isAutoField || isAluminiumCasingThickness || valueArray.length === 1;

    return (
      <>
        {valueArray?.length > 0 ? (
          showAsInput ? (
            <input
              type="text"
              className="form-control"
              value={isAluminiumCasingThickness ? "1.2 mm (18 ga)" : (matchedConfig?.valueName || options[0]?.label || "")}
              readOnly
            />
          ) :
            isRalCustomColour(attribute, matchedConfig) ? (
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder={`Enter ${attribute?.attributeName}`}
                  value={typeof selectedValue === "string" ? selectedValue : ""}
                  name={attribute?.attributeName}
                  onChange={(e) => handleChange(e, attribute, "text", group)}
                />
                <span
                  className="input-group-text"
                  id="basic-addon2"
                  onClick={() =>
                    handleChange(
                      { target: { value: "", name: attribute?.attributeName } },
                      attribute,
                      "text",
                      group
                    )
                  }
                >
                  <i className="fas fa-times"></i>
                </span>
              </div>
            ) : (
              <Select
                className="basic-multi-select product-config-select"
                options={options}
                name={attribute?.attributeName}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                isClearable={false}
                isSearchable={true}
                onChange={(e) => handleChange(e, attribute, "select", group)}
                allowSelectAll={false}
                value={selectedValue}
                styles={style}
                placeholder="Select..."
                menuPlacement="auto"
                menuPortalTarget={document.body}
                menuPosition="fixed"
                minMenuHeight={0}
              />
            )
        ) : (
          <input
            type="text"
            className="form-control"
            placeholder={`Enter ${attribute?.attributeName}`}
            value={typeof selectedValue === "string" ? selectedValue : ""}
            name={attribute?.attributeName}
            onChange={(e) => handleChange(e, attribute, "text", group)}
          />
        )}

        {configError?.[attribute?.attributeName] && (
          <p className="form-error mb-0 mt-1">{configError?.[attribute?.attributeName]}</p>
        )}
      </>
    );
  };

  const visibleAttributeCount = attributeArray?.filter((attr) => {
    if (attr?.isSelectionParameter === true) {
      return false;
    }
    if (
      checkShowAttribute(attr) === false &&
      urls.SHOW_ATTRIBUTES_ARRAY.includes(attr?.attributeId)
    ) {
      return false;
    }
    return true;
  })?.length || 0;

  const selectedConfigCount = configSetting?.filter(
    (config) => CheckNull(config?.valueName) !== "" || CheckNull(config?.specialValue) !== ""
  )?.length || 0;

  const accordionContent = (
    <div className="accordion" id={inline ? "configurationsAccordionTab" : "configurationsAccordionExample"}>
      {groupArray?.map((group, index) => {
        return (
          <div className="card" key={group?.groupId}>
            <div className="card-head" id={`${inline ? "tab" : ""}${index}head`}>
              <h2
                data-toggle="collapse"
                data-target={`#${inline ? "tabid" : "id"}${index}`}
                aria-expanded={index === 0 ? "true" : "false"}
                aria-controls={`${inline ? "tabid" : "id"}${index}`}
              >
                {group?.groupName}
              </h2>
            </div>
            <div
              id={`${inline ? "tabid" : "id"}${index}`}
              className={index === 0 ? "collapse show" : "collapse"}
              aria-labelledby={`${inline ? "tab" : ""}${index}head`}
              data-parent={`#${inline ? "configurationsAccordionTab" : "configurationsAccordionExample"}`}
            >
              <div className="card-body">
                <div className="row">
                  {attributeArray
                    ?.filter((item) => item.groupId === group?.groupId)
                    ?.map((attr, attrIndex) => GetSelectComponent(attr, group))}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );

  if (inline) {
    return (
      <div className="product-config-workspace">
        <div className="model-config-container">
          <div className={`model-config-toolbar ${headerExtra ? "has-tabs" : ""}`}>
            <div>
              {headerExtra ? headerExtra : <h3>Model Configuration</h3>}
              {headerExtra ? "" : <span>{selectedConfigCount} of {visibleAttributeCount} configured</span>}
            </div>
          </div>
          {groupArray
            ?.filter((group) => !groupFilter || groupFilter(group))   // NEW
            ?.map((group) => {
              const groupAttributes = attributeArray?.filter(
                (item) => item.groupId === group?.groupId
              );
              const visibleGroupAttributes = groupAttributes?.filter((attr) => {
                if (attr?.isSelectionParameter === true) {
                  return false;
                }
                if (
                  checkShowAttribute(attr) === false &&
                  urls.SHOW_ATTRIBUTES_ARRAY.includes(attr?.attributeId)
                ) {
                  return false;
                }
                return true;
              });

              if (!visibleGroupAttributes?.length) return null;

              return (
                <div className="model-config-group" key={group?.groupId}>
                  <div className="model-config-group-header">
                    <span>{group?.groupName}</span>
                    <small>{visibleGroupAttributes.length} field{visibleGroupAttributes.length === 1 ? "" : "s"}</small>
                  </div>
                  <div className="model-config-rows">
                    {visibleGroupAttributes.map((attr, attrIndex) => (
                      <div className="model-config-row" key={attr?.attributeId}>
                        <div className="model-config-slno">{attrIndex + 1}</div>
                        <div className="model-config-parameter">{attr?.attributeName}</div>
                        <div className="model-config-value flex-column align-items-start">{GetTableValueControl(attr, group)}</div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="configurations-tab">
        <ul className="pl-1">
          <li>
            <input id="rad1" type="radio" name="rad" className="radio-btn-input" />
            <label
              htmlFor="rad1"
              className="configurations-label"
              data-toggle="modal"
              data-target="#configurationsRightSideModalPopup"
            >
              <div onClick={() => { setOpenConfiguration(true); }}>
                <i className="fas fa-cog"></i> Configurations
              </div>
            </label>
          </li>
        </ul>

        <Modal
          size="sm"
          show={openConfiguration}
          className="configurationsRightSideModalPopup drawer right-align"
        >
          <Modal.Header>
            <h5 className="modal-title">Configuration</h5>
            <i
              className="fas fa-times"
              onClick={() => { setOpenConfiguration(false); }}
            ></i>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                {accordionContent}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};
